import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import GatewayPage from "@/pages/GatewayPage";
import ConsultingPage from "@/pages/LandingPage";
import AppsPage from "@/pages/AppsPage";
import PrivacyPage from "@/pages/PrivacyPage";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GatewayPage />} />
            <Route path="/consulting" element={<ConsultingPage />} />
            <Route path="/apps" element={<AppsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
